module.exports = __webpack_public_path__ + "img/logo-text-light.a1c9f55c.png";